// Reports client-side errors and failed API calls to the backend (admin Log tab).
const report = (kind, message, detail) => {
  try {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/client-errors`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        kind,
        message: String(message || "").slice(0, 300),
        detail: String(detail || "").slice(0, 300),
        path: window.location.pathname,
        ua: (navigator.userAgent || "").slice(0, 150),
      }),
      keepalive: true,
    });
  } catch { /* never break the app */ }
};

export function initErrorReporter() {
  window.addEventListener("error", (e) => {
    report("js_error", e.message, `${e.filename || ""}:${e.lineno || ""}`);
  });
  window.addEventListener("unhandledrejection", (e) => {
    report("unhandled_rejection", e.reason?.message || e.reason);
  });
}

export function reportApiError(cfg, status, detail) {
  report("api_error", `${status} ${cfg?.method?.toUpperCase()} ${cfg?.url}`, detail);
}
